import React from "react";
import styled from "styled-components";

const HeaderContainer = styled.header`
  background-color: #ebaf2e;
  color: white;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Roboto", "Arial", sans-serif;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
`;

const Logo = styled.img`
  height: 50px;
  width: auto;
  margin-right: 1rem;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const WelcomeText = styled.span`
  font-size: 1.1rem;
  font-weight: 500;
  color: white;
`;

const Button = styled.button`
  background-color: #666666;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;

  &:hover {
    background-color: #005a9e;
  }
`;

interface HeaderProps {
  isAuthenticated: boolean;
  user?: any;
  onLogin: () => void;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({
  isAuthenticated,
  user,
  onLogin,
  onLogout,
}) => {
  return (
    <HeaderContainer>
      <LeftSection>
        <Logo src="/img/logo.png" alt="ARC Logo" />
        <Title>ARC Policy Chatbot</Title>
      </LeftSection>
      <UserInfo>
        {
          isAuthenticated ? (
            <>
              <WelcomeText>
                Welcome, {user?.name || user?.username || "User"}
              </WelcomeText>
              <Button onClick={onLogout}>Logout of Azure</Button>
            </>
          ) : null
          //<Button onClick={onLogin}>Login</Button>
        }
      </UserInfo>
    </HeaderContainer>
  );
};

export default Header;
